function actOnHash(e) {
    if(location.hash.length > 1) {
        if(location.hash.substring(1, 7) === "layer_") {
            var onElement = document.querySelector(".on");
            if(onElement) {
                onElement.classList.remove("on");
            }
            document.querySelector("#layerBackground").setAttribute("data-open", location.hash.substring(7));
        } else {
            document.querySelector("#layerBackground").setAttribute("data-open", "");
            var target = document.querySelector(location.hash);
            if(target) {
                target.classList.add("on");
            } else {
                var onElement = document.querySelector(".on");
                if(onElement) {
                    onElement.classList.remove("on");
                }
            }
        }
    } else {
        var onElement = document.querySelector(".on");
        if(onElement) {
            onElement.classList.remove("on");
        }
        document.querySelector("#layerBackground").setAttribute("data-open", "");
    }
}

addEventListener("hashchange", actOnHash);
actOnHash();


(function() {
    var languageSelector = document.querySelector("#languageSelector");
    if(languageSelector !== null) {
        var mobileMenu = document.querySelector("header .wp-block-navigation__responsive-container-content");
        mobileMenu.insertBefore(languageSelector.cloneNode(true), mobileMenu.firstElementChild);
    }
})();


(function() {
    var breadcrumb = document.querySelector(".yoast-breadcrumbs");
    if(breadcrumb) {
        var span = document.createElement("span");
        var as = breadcrumb.querySelectorAll("a");
        if(as.length > 0) {
            lastA = as[as.length - 1];
            var back = "<a class='breadcrumb-back' href='" + lastA.href + "'>" + I18N.back + "</a>";
        } else {
            var back = "<a class='breadcrumb-back' href='\\'>" + I18N.back + "</a>";;
        }
        span.innerHTML = back + "<span class='breadcrumb-starter'>" + I18N.here + "</span>";
        span.className = "breadcrumb-prefix";
        breadcrumb.firstElementChild.insertBefore(span, breadcrumb.firstElementChild.firstElementChild);
        var content = document.querySelector("main > .wp-block-post-content");
        if(content) {
            if(content.childElementCount < 2) {
                content.appendChild(breadcrumb);
            } else {
                content.insertBefore(breadcrumb, content.children[1]);
            }
        } else {
            document.querySelector("main").appendChild(breadcrumb);
        }
    }
})();


// returns like its name implies or document.documentElement if no suiting element found
function closestElementParentHavingClass(element, classname) {
    while(!element.classList.contains(classname)) {
        element = element.parentElement;
        if(element === document.documentElement) {
            break;
        }
    }
    return element;
}


document.body.addEventListener("close", function(e) {
    var p = closestElementParentHavingClass(e.target, "on");
    if(p.classList.contains("on")) {
        p.classList.remove("on");
        if(location.hash.substring(1) === p.id) {
            var s = document.documentElement.scrollTop;
            location.hash = "";
            document.documentElement.scrollTop = s;
        }
    }
});


(function breakContentToNextColumn() {
    document.querySelectorAll(".is-style-two-columnned-content > p").forEach(function(p) {
        if(p.textContent === "|") {
            p.classList.add("column-break");
        }
    });
})();


/**
 *  slider
 */

var slides = [];
document.querySelectorAll(".js-slider").forEach(function(slider) {
    slider.dataset.index = "" + slides.length;
    var anzahlen = slider.nextElementSibling;
    var anzahl = +anzahlen.dataset.anzahl;
    var anzahlDesktopMax = +anzahlen.dataset.anzahldesktopmax;
    var anzahlMobileMax = +anzahlen.dataset.anzahlmobilemax;
    var amountItemsMobile = !isNaN(anzahlMobileMax) && anzahl <= anzahlMobileMax ? anzahl : anzahlMobileMax;
    var showMobile = amountItemsMobile !== anzahl;
    var amountItemsDesktop = !isNaN(anzahlDesktopMax) && anzahl <= anzahlDesktopMax ? anzahl : anzahlDesktopMax;
    var showDesktop = amountItemsDesktop !== anzahl;
    var nav = slider.parentElement.querySelector(".slider-nav");
    slides.push(tns({
        container: slider,
        controls: false,
        nav: false,
        responsive: {
            1: {
                items: amountItemsMobile
            },
            992: {
                items: amountItemsDesktop
            }
        }
    }));
    showMobile ? 1 : nav.classList.add("mobile-hide");
    showDesktop ? 1 : nav.classList.add("desktop-hide");
    var navdotss = nav.querySelectorAll(".slider-nav-dots");
    navdotss.forEach(function(navdots) {
        navdots.firstElementChild.classList.add("active");
    });
    slides[slides.length - 1].events.on("indexChanged", function(e) {
        var navdots = navdotss[innerWidth < 992 ? 0 : 1];
        navdots.querySelector(".active").classList.remove("active");
        navdots.children[e.displayIndex - 1].classList.add("active");
    });
});
function gotoSlide() {
    slides[+closestElementParentHavingClass(this, "slider-nav").parentElement.querySelector(".js-slider").dataset.index].goTo(Array.prototype.indexOf.call(this.parentElement.children, this));
}
document.querySelectorAll(".nav-dot").forEach(function(dot) {
    dot.addEventListener("click", gotoSlide);
});
function gotoPrevSlide() {
    var sliderNav = closestElementParentHavingClass(this, "slider-nav");
    var active = sliderNav.querySelector("." + (innerWidth < 992 ? "mobile" : "desktop") + "-only .active");
    var index = Array.prototype.indexOf.call(active.parentElement.children, active);
    var amount = active.parentElement.children.length;
    active.parentElement.children[(index - 1 + amount) % amount].click();
}
document.querySelectorAll(".slider-nav .prev").forEach(function(prev) {
    prev.addEventListener("click", gotoPrevSlide);
});
function gotoNextSlide() {
    var sliderNav = closestElementParentHavingClass(this, "slider-nav");
    var active = sliderNav.querySelector("." + (innerWidth < 992 ? "mobile" : "desktop") + "-only .active");
    var index = Array.prototype.indexOf.call(active.parentElement.children, active);
    var amount = active.parentElement.children.length;
    active.parentElement.children[(index + 1) % amount].click();
}
document.querySelectorAll(".slider-nav .next").forEach(function(prev) {
    prev.addEventListener("click", gotoNextSlide);
});


// select label change
var openedSelectByUser = null;
function setOpened(e) {
    openedSelectByUser = this;
}
function setSelected(e) {
    if(this === openedSelectByUser) {
        this.setAttribute("hasselection", "");
    }
}
document.querySelectorAll("select").forEach(function(e) {
    e.addEventListener("click", setOpened);
    e.addEventListener("change", setSelected);
});


// contact form 7 inputs
function putValue() {
    this.parentElement.setAttribute("data-input", this.value);
}
document.querySelectorAll(".wpcf7-form-control-wrap > input").forEach(function(input) {
    input.addEventListener("input", putValue);
    putValue.call(input);
});
document.querySelectorAll(".wpcf7-form-control-wrap > select").forEach(function(select) {
    select.addEventListener("change", putValue);
    putValue.call(select);
});


// faq links
document.querySelectorAll(".faq-text").forEach(function(faqText) {
    function focusBack() {
        faqText.focus();
        removeEventListener("focus", focusBack);
    }
    function openLink() {
        this.click();
        addEventListener("focus", focusBack);
    }
    faqText.querySelectorAll("a").forEach(function(a) {
        a.addEventListener("mousedown", openLink);
    });
});


// layer close
function closeLayer(e) {
    if(this === e.target) {
        var s = document.documentElement.scrollTop;
        location.hash = "";
        document.documentElement.scrollTop = s;
    }
}
document.querySelectorAll(".layer").forEach(function(layer) {
    layer.addEventListener("click", closeLayer);
});


// mobile menu open/close
document.getElementById('mobile-menu-btn').addEventListener('click', function() {
    document.documentElement.classList.add('has-modal-open');

    document.getElementById('modal-1').classList.add('is-menu-open', 'has-modal-open');
    document.getElementById('modal-1').setAttribute('aria-hidden', 'false');
    
    document.querySelector('#modal-1 .wp-block-navigation__responsive-dialog').setAttribute('aria-modal', 'true');
    document.querySelector('#modal-1 .wp-block-navigation__responsive-dialog').setAttribute('role', 'dialog');
});

document.querySelector('#modal-1 .wp-block-navigation__responsive-container-close').addEventListener('click', function() {
    document.documentElement.classList.remove('has-modal-open');

    document.getElementById('modal-1').classList.remove('is-menu-open', 'has-modal-open');
    document.getElementById('modal-1').setAttribute('aria-hidden', 'true');
    
    document.getElementById('modal-1').querySelector('#modal-1 .wp-block-navigation__responsive-dialog').removeAttribute('aria-modal');
    document.getElementById('modal-1').querySelector('#modal-1 .wp-block-navigation__responsive-dialog').removeAttribute('role');
});